// Shared auth contract between AuthGuard (writer) and LoginPage (reader):
// the sessionStorage key holding the path to return to after login.
export const AUTH_RETURN_KEY = 'orbit_auth_return';

/**
 * Reads (without clearing) the internal path to return to after login: an
 * explicit `?return=` on /login first, else what AuthGuard stashed before
 * redirecting. Only same-origin paths are accepted (guards against
 * open-redirect); falls back to '/'.
 *
 * `?return=` exists for the pages that reach /login WITHOUT going through
 * AuthGuard — the shareable ticket link (/api/orbit/ref/ORB-14/go) is a
 * Drupal redirect, so nothing ever wrote the sessionStorage key for it.
 */
export function readReturnPath() {
  try {
    const raw = new URLSearchParams(window.location.search).get('return');
    if (raw && raw.startsWith('/')) {
      // Attacker-controlled, unlike the sessionStorage value: resolve it like
      // the browser would ("/\evil.com" is "//evil.com") and keep it only if
      // it stays on this origin.
      const url = new URL(raw, window.location.origin);
      if (url.origin === window.location.origin) return url.pathname + url.search + url.hash;
    }
  } catch (_) { /* malformed URL */ }
  try {
    const p = sessionStorage.getItem(AUTH_RETURN_KEY);
    if (p && p.startsWith('/') && !p.startsWith('//')) return p;
  } catch (_) { /* sessionStorage unavailable */ }
  return '/';
}
